export default __webpack_public_path__ + "static/media/delete.466276d6.svg";